// Page copy. Arabic leads (public page for Iraqi merchants); English is one tap away.
import type { Locale } from './application';

const ar = {
  langSwitch: 'English',
  kicker: 'للتجار والشركاء',
  title: 'انضم إلى ياقوت كشريك',
  lead: 'قدّم عروضك لأعضاء نادي ياقوت. سجّل نشاطك التجاري وسيتواصل معك فريقنا لمراجعة الطلب وتفعيله.',
  whyTitle: 'لماذا ياقوت؟',
  values: [
    ['آلاف العملاء الجدد قريبون منك', 'يظهر نشاطك في التطبيق وعلى الخريطة لآلاف الأعضاء الذين يبحثون عن عروض في منطقتهم.'],
    ['مكانك بين أبرز العلامات التجارية', 'انضم إلى قائمة مختارة من أفضل المطاعم والمتاجر والخدمات في مدينتك، تحت اسم ياقوت.'],
    ['أعضاء مشتركون وموثّقون', 'الخصم لأعضاء ياقوت المشتركين فقط، ويُتحقق من كل عضو برمز QR في تطبيق التاجر.'],
    ['زيارات متكررة', 'العضو يعود إلى الأماكن التي يحصل فيها على خصم، فيتحوّل الزائر الأول إلى زبون دائم.'],
  ] as [string, string][],
  steps: 'الخطوات: تقديم الطلب ← مراجعة الفريق ← تفعيل الحساب وإرسال دعوة لتطبيق التاجر',
  s1: 'النشاط والعرض',
  nameAr: 'اسم النشاط',
  category: 'الفئة',
  categoryPick: 'اختر الفئة',
  loading: 'جارٍ التحميل…',
  branchCount: 'عدد الفروع',
  branches: { '1': 'فرع واحد', '2-5': '2 – 5', '6+': '6 فأكثر' },
  s2: 'الموقع',
  mapLabel: 'موقع الفرع الرئيسي',
  mapHint: 'ابحث عن المكان أو اضغط على الخريطة لوضع الدبوس.',
  myLocation: 'استخدم موقعي الحالي',
  searchPlaceholder: 'ابحث عن عنوان أو مكان، مثل: شارع الكرادة داخل',
  search: 'بحث',
  searching: 'جارٍ البحث…',
  noResults: 'لا توجد نتائج. جرّب اسماً آخر أو ضع الدبوس يدوياً.',
  searchFailed: 'تعذّر البحث الآن. ضع الدبوس يدوياً على الخريطة.',
  locating: 'جارٍ تحديد الموقع…',
  locateFailed: 'تعذّر تحديد موقعك. ضع الدبوس يدوياً على الخريطة.',
  pinSet: 'تم تحديد الموقع',
  clearPin: 'إزالة',
  s3: 'الشخص المسؤول',
  s3Hint: 'سيصبح هذا الشخص مالك حساب التاجر بعد الموافقة.',
  contactName: 'الاسم الكامل',
  contactMobile: 'رقم الموبايل',
  contactEmail: 'البريد الإلكتروني (اختياري)',
  discount: 'نسبة الخصم لأعضاء ياقوت',
  termsTitle: 'شروط الشراكة',
  viewTerms: 'عرض شروط الشراكة',
  close: 'إغلاق',
  terms: 'هذا الطلب ليس عقداً، ولا تسري الشروط إلا بعد توقيع عقد رسمي بين الشريك وياقوت. بعد توقيع العقد، يلتزم الشريك بتقديم الخصم المتفق عليه لأعضاء ياقوت طوال مدة العرض، وعلى المنتجات والخدمات المحددة في العرض فقط، دون غيرها، ودون أن يشمل أي منتجات محظورة. ولإيقاف عرض قبل تاريخ انتهائه، يجب التواصل مع ياقوت والاتفاق على ذلك مسبقاً.',
  consent: 'قرأت شروط الشراكة وأوافق عليها، وعلى أن يتواصل معي فريق ياقوت بخصوص هذا الطلب.',
  submit: 'إرسال الطلب',
  submitting: 'جارٍ الإرسال…',
  fixErrors: 'يرجى تصحيح الحقول المحددة.',
  rateLimited: 'وصلنا عدد كبير من الطلبات من هذا الاتصال أو الرقم. حاول مرة أخرى لاحقاً.',
  submitFailed: 'تعذّر إرسال الطلب. تحقق من الاتصال وحاول مرة أخرى.',
  errors: {
    required: 'هذا الحقل مطلوب',
    invalidMobile: 'أدخل رقم موبايل عراقي، مثل 0790 123 4567',
    invalidEmail: 'أدخل بريداً إلكترونياً صحيحاً',
    arabicName: 'اكتب الاسم بالأحرف العربية',
    location: 'ضع الدبوس على موقع النشاط',
    consent: 'يجب الموافقة للمتابعة',
  },
  doneTitle: 'تم استلام طلبك',
  doneBody: 'شكراً لاهتمامك بالانضمام إلى ياقوت. سيراجع فريقنا الطلب ويتواصل معك عبر الموبايل أو البريد الإلكتروني.',
  reference: 'رقم الطلب',
  doneNext: 'بعد الموافقة ستصلك دعوة لتطبيق التاجر لإكمال الصور والعروض.',
  another: 'تقديم طلب آخر',
  localNote: 'وضع التجربة المحلي: لم يُرسل الطلب إلى الخادم.',
  footer: 'ياقوت · نادي الخصومات والعضويات',
};

type Strings = typeof ar;

const en: Strings = {
  langSwitch: 'العربية',
  kicker: 'For merchants and partners',
  title: 'Join Yakoot as a partner',
  lead: 'Offer your deals to Yakoot club members. Register your business and our team will get in touch to review and activate it.',
  whyTitle: 'Why Yakoot?',
  values: [
    ['Thousands of new customers nearby', 'Your business shows in the app and on the map to thousands of members looking for deals in their area.'],
    ['A place among top brands', 'Join a curated list of the best restaurants, shops and services in your city, under the Yakoot name.'],
    ['Paying, verified members', 'The discount is only for subscribed Yakoot members, each verified by a QR code in the merchant app.'],
    ['Repeat visits', 'Members come back to the places where they get a discount, turning first visits into regulars.'],
  ],
  steps: 'Steps: submit the form → team review → account activated and a merchant app invite sent',
  s1: 'Business and offer',
  nameAr: 'Business name (in Arabic)',
  category: 'Category',
  categoryPick: 'Choose a category',
  loading: 'Loading…',
  branchCount: 'Number of branches',
  branches: { '1': 'One', '2-5': '2–5', '6+': '6+' },
  s2: 'Location',
  mapLabel: 'Main branch location',
  mapHint: 'Search for the place or tap the map to drop the pin.',
  myLocation: 'Use my current location',
  searchPlaceholder: 'Search an address or place, e.g. Karrada Dakhil street',
  search: 'Search',
  searching: 'Searching…',
  noResults: 'No results. Try another name or drop the pin yourself.',
  searchFailed: "Search isn't available right now. Drop the pin on the map instead.",
  locating: 'Finding your location…',
  locateFailed: "Couldn't find your location. Drop the pin on the map instead.",
  pinSet: 'Location set',
  clearPin: 'Remove',
  s3: 'Contact person',
  s3Hint: 'This person becomes the owner of the merchant account once approved.',
  contactName: 'Full name',
  contactMobile: 'Mobile number',
  contactEmail: 'Email (optional)',
  discount: 'Discount for Yakoot members',
  termsTitle: 'Partner terms',
  viewTerms: 'View the partner terms',
  close: 'Close',
  terms: 'This application is not a contract; the terms apply only once an official contract is signed between the partner and Yakoot. After signing, partners give Yakoot members the agreed discount for the full duration of each offer, only on the products and services listed in the offer, not on other items, and never on prohibited items. To withdraw an offer before its end date, contact Yakoot first and agree on it.',
  consent: 'I have read and agree to the partner terms, and to the Yakoot team contacting me about this application.',
  submit: 'Submit application',
  submitting: 'Submitting…',
  fixErrors: 'Please fix the highlighted fields.',
  rateLimited: 'Too many applications from this connection or number. Please try again later.',
  submitFailed: "Couldn't send the application. Check your connection and try again.",
  errors: {
    required: 'This field is required',
    invalidMobile: 'Enter an Iraqi mobile number, e.g. 0790 123 4567',
    invalidEmail: 'Enter a valid email address',
    arabicName: 'Write the name in Arabic letters',
    location: 'Drop the pin on your business location',
    consent: 'You need to agree to continue',
  },
  doneTitle: 'Application received',
  doneBody: 'Thank you for your interest in joining Yakoot. Our team will review your application and contact you by mobile or email.',
  reference: 'Reference',
  doneNext: 'Once approved, you will get a merchant app invite to add photos and offers.',
  another: 'Submit another application',
  localNote: 'Local preview: the application was not sent to a server.',
  footer: 'Yakoot · the discount and membership club',
};

export const STRINGS: Record<Locale, Strings> = { ar, en };
export type { Strings };
